import { useCallback, useMemo } from 'react'

import { FormControlLabel, Radio, RadioGroup } from '@mui/material'

import { useTexts } from '../../../hooks/useTexts'
import { createValidateCourierFilterVehicles } from '../../../hooks/validations/createValidateCourierFilterVehicles'

import { form } from '../../../formState'

import { VehiclesRestrictionValue } from '../../../types'

export type Option = string[]

type Props = {
  territoryId: string
  territoriesData: uui.domain.client.rm.TerritoriesDriversAndVehicles
}

export function VehiclesAccess(props: Props) {
  const { territoryId, territoriesData } = props
  const texts = useTexts()
  const { api, values } = form.useForm()

  const type = form.useFormField('type')

  const vehicleIdRestrictionFieldValue = values.vehicles?.[territoryId]?.restriction
  const restriction = vehicleIdRestrictionFieldValue || 'not-restricted'

  const items = useMemo(() => {
    return Object.keys(territoriesData[territoryId]?.vehicles ?? {})
  }, [territoriesData, territoryId])

  const onRadioChange = useCallback(
    value => {
      api.change(`vehicles.${territoryId}.ids`, [])
      api.change(`vehicles.${territoryId}.restriction`, value)
    },
    [api, territoryId],
  )

  const getOptionLabel = useCallback(
    (option: string) => {
      return territoriesData[territoryId]?.vehicles?.[option] ?? ''
    },
    [territoriesData, territoryId],
  )

  return (
    <form.Fieldset spacing={0.5}>
      <form.SectionSubtitle>{texts.labels.vehicles.title}</form.SectionSubtitle>

      <RadioGroup
        value={restriction}
        onChange={e => onRadioChange(e.target.value as VehiclesRestrictionValue)}
        name={`vehicles.${territoryId}.restriction`}
      >
        <FormControlLabel
          value="not-restricted"
          control={<Radio />}
          label={texts.labels.notRestricted}
        />
        <FormControlLabel value="restricted" control={<Radio />} label={texts.labels.restricted} />
      </RadioGroup>

      {restriction === 'restricted' && (
        <form.MultiSelect
          key={territoryId}
          name={`vehicles.${territoryId}.ids`}
          validateOn="blur change"
          onValidate={(field: { value: Option[] }) => {
            const validationCourierFilterVehicles = createValidateCourierFilterVehicles(
              texts,
              field.value ?? ([] as unknown as Option[]),
              type.field.value,
              restriction,
            )
            return validationCourierFilterVehicles?.courierFilterVehicleErrors?.message
          }}
          multiSelectProps={{
            label: texts.labels.vehicles.fieldLabel,
            items: items ?? [],
            getLabel: getOptionLabel,
            inputMode: 'normal',
            optionMode: 'normal',
          }}
        />
      )}
    </form.Fieldset>
  )
}
